import { Typography, useTheme } from "@mui/material";
import { useIsMobile } from "Hooks";

const Footer = () => {
  const { palette } = useTheme();
  const isMobile = useIsMobile();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: "10px",
        paddingTop: "25px",
        flexDirection: "column",
      }}
    >
      {isMobile ? (
        <>
          <Typography variant='caption' color='text.secondary'>
            All Rights Reserved. Luke Weathington ©{new Date().getFullYear()}
          </Typography>
          <Typography variant='caption' color='text.secondary'>
            Design:{" "}
            <a
              href='https://zacevanscoding.com'
              target='_blank'
              rel='noreferrer'
              style={{ color: palette.primary.main }}
            >
              Zac Evans
            </a>
          </Typography>
        </>
      ) : (
        <Typography variant='caption' color='text.secondary'>
          All Rights Reserved. Luke Weathington ©{new Date().getFullYear()} |
          Design:{" "}
          <a
            href='https://zacevanscoding.com'
            target='_blank'
            rel='noreferrer'
            style={{ color: palette.primary.main }}
          >
            Zac Evans
          </a>
        </Typography>
      )}
    </div>
  );
};

export default Footer;
